import { render, staticRenderFns } from "./security.vue?vue&type=template&id=b2f2326a&scoped=true"
import script from "./security.vue?vue&type=script&lang=js"
export * from "./security.vue?vue&type=script&lang=js"
import style0 from "./security.vue?vue&type=style&index=0&id=b2f2326a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f2326a",
  null
  
)

export default component.exports